import React, { useState } from 'react';
import InputIcon from '../InputIcon/index.js';
import { sendEmailWhats } from '../../Libs/Docs.js';
import ModalComponent from '../../components/Modal';
import IconEmail from '../../assets/svg/ic-contact-mail.svg';
import IconFone from '../../assets/svg/ic-contact-phone.svg';
import { Row, Col } from 'reactstrap';
import PreLoaderWidget from '../../components/Loader';

const ModalEnvio = ({ visible, close, card, pacienteId, docId, email, telefone, visualizar = false }) => {

    const [sending, setSending] = useState({ email: false, whats: false, ambos: false });
    const [disabled, setDisabled] = useState(false);
    const [emailSend, setEmailSend] = useState(email);
    const [telefonesSend, setTelefonesSend] = useState(telefone);

    const sleep = (ms) => {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    const sendEmailWhatsBoth = async (tipo_receita = null) => {
        setDisabled(true);
        setSending({ ...sending, ambos: true });
        console.log("enviando email")
        // await sendEmailWhatsIntern('E', false, tipo_receita);
        // await sleep(200);
        setSending({ ...sending, ambos: true });
        // await sendEmailWhatsIntern('W', false, tipo_receita);
        await sendEmailWhatsIntern('BOTH', false, tipo_receita);
        setSending({ ...sending, ambos: false });

        await sleep(200);
        setDisabled(false);
        await sleep(200);

        alert('Foi disparado um email e whatsapp para os dados inseridos no formulário');
        close();
    }

    const sendEmailWhatsIntern = async (tipo, comAlerta, tipo_receita = null) => {

        let dados = (tipo === 'E') ? emailSend : telefonesSend;
        if (tipo === 'BOTH') {
            dados = JSON.stringify({
                'telefones': telefonesSend,
                'emails': emailSend
            })
        }

        if (comAlerta) {
            setDisabled(true);
            if (tipo === 'E')
                setSending({ ...sending, email: true });
            else
                setSending({ ...sending, whats: true });
        }
        if (card === "solicitacao_exame") {
            await sendEmailWhats(pacienteId, docId, tipo, dados, 'solicitacao_exame').then((res) => {
                if (comAlerta)
                    alert(res);
            }).catch((err) => {
                if (comAlerta)
                    alert(err);
            });
        }
        if (card === "receituario") {
            await sendEmailWhats(pacienteId, docId, tipo, dados, 'receituario_exame').then(res => {
                if (comAlerta)
                    alert(res);
            }).catch(err => {
                if (comAlerta)
                    alert(err);
            });
        }
        if (card === "receita") {
            let tipo_documento = (tipo_receita === 'Comum') ? 'receituario_info' : 'receituario_especial';
            await sendEmailWhats(pacienteId, docId, tipo, dados, tipo_documento).then((res) => {
                if (comAlerta)
                    alert(res);
            }).catch((err) => {
                if (comAlerta)
                    alert(err);
            });
        }
        if (card === "atestado") {
            await sendEmailWhats(pacienteId, docId, tipo, dados, 'atestado').then(res => {
                if (comAlerta)
                    alert(res);
            }).catch(err => {
                if (comAlerta)
                    alert(err);
            });
        }


        if (comAlerta) {
            setDisabled(false);
            close();
        }
        console.log("setSending false?")
        setSending({ ...sending, email: false, whats: false });
    }

    const getTipo = () => {
        if (card === "solicitacao_exame")
            return ' Solicitação de exame';
        else if (card === "receituario")
            return ' Receituário';
        else if (card === "receita")
            return ' Receita';
        else if (card === "atestado")
            return ' Atestado';
    }

    const renderButtonEmail = () => {
        if (sending.email)
            return <div><PreLoaderWidget ></PreLoaderWidget></div>

        return (
            <div>
                <button
                    onClick={() => { sendEmailWhatsIntern('E', true); }}
                    className="btn gb-button to-form full"
                    disabled={disabled}>
                    Enviar
                </button>
            </div>
        )
    }

    const renderButtonEmailReceita = () => {
        if (sending.email)
            return <div><PreLoaderWidget ></PreLoaderWidget></div>

        return (
            <div className="gb-row">
                <button
                    onClick={() => { sendEmailWhatsIntern('E', true, 'Comum'); }}
                    className="btn gb-button-border to-form"
                    disabled={disabled}>
                    Envio Comum
                </button>
                <button
                    onClick={() => { sendEmailWhatsIntern('E', true, 'Especial'); }}
                    className="btn gb-button to-form ml-3"
                    disabled={disabled}>
                    Envio Especial
                </button>
            </div>
        )
    }

    const renderButtonWhats = () => {
        if (sending.whats)
            return <div><PreLoaderWidget ></PreLoaderWidget></div>

        return (
            <div>
                <button
                    onClick={() => { sendEmailWhatsIntern('W', true); }}
                    className="btn gb-button to-form full"
                    disabled={disabled}>
                    Enviar
                </button>
            </div>
        )
    }

    const renderButtonWhatsReceita = () => {
        if (sending.whats)
            return <div><PreLoaderWidget ></PreLoaderWidget></div>

        return (
            <div className="gb-row">
                <button
                    onClick={() => { sendEmailWhatsIntern('W', true, 'Comum'); }}
                    className="btn gb-button-border to-form"
                    disabled={disabled}>
                    Envio Comum
                </button>
                <button
                    onClick={() => { sendEmailWhatsIntern('W', true, 'Especial'); }}
                    className="btn gb-button to-form ml-3"
                    disabled={disabled}>
                    Envio Especial
                </button>
            </div>
        )
    }

    const renderFooter = () => {
        return (
            <Row className="mt-3">
                <Col xs={12} md={8}>
                    {sending.ambos ? (<div><PreLoaderWidget ></PreLoaderWidget></div>) : <><button
                        onClick={() => sendEmailWhatsBoth()}
                        className="btn gb-button full"
                        disabled={disabled}>
                        Enviar por Email e Whatsapp
                    </button></>}
                </Col>
                <Col xs={12} md={4}>
                    {(visualizar != false) ? <button className="btn gb-button-border full" onClick={() => visualizar()} disabled={disabled}>Visualizar</button> : <button className="btn gb-button-border full" onClick={() => close()} disabled={disabled}>Fechar</button>}
                </Col>
            </Row>
        )
    }

    const renderFooterReceita = () => {
        return (
            <Row className="mt-3">
                <Col xs={12} md={6}>
                    {sending.ambos ? (<div><PreLoaderWidget ></PreLoaderWidget></div>) : <>
                        <button
                            onClick={() => sendEmailWhatsBoth('Comum')}
                            className="btn gb-button-border full mb-2"
                            disabled={disabled}>
                            Enviar por Email e Whatsapp Comum
                        </button>

                        <button
                            onClick={() => sendEmailWhatsBoth()}
                            className="btn gb-button full"
                            disabled={disabled}>
                            Enviar por Email e Whatsapp Especial
                        </button>
                    </>}
                </Col>
                <Col xs={12} md={6} style={{ borderLeftWidth: 1, borderColor: '#F0F0f0' }}>
                    {(visualizar != false) ? <>
                        <p style={{ fontSize: 18, fontWeight: 600 }}>Visualizar Receita</p>
                        <div className="gb-row">
                            <button className="btn gb-button-border full" onClick={() => visualizar('Comum')} disabled={disabled}>Comum</button>
                            <button className="btn gb-button full ml-2" onClick={() => visualizar('Especial')} disabled={disabled}>Especial</button>
                        </div>
                    </> : <button className="btn gb-button-border full" onClick={() => close()} disabled={disabled}>Fechar</button>}
                </Col>
            </Row>
        )
    }

    // console.log("sending", sending)
    return (
        <div>
            <ModalComponent
                openModal={visible}
                closeModal={() => close()}
                auto
            >
                <div>
                    <div style={{ minWidth: 600, }}>
                        <p style={{ fontSize: 18, fontWeight: 600 }}>Enviar{getTipo()}</p>
                        <hr />

                        <p style={{ fontSize: 16, fontWeight: 500 }}>Via email</p>

                        <Row>
                            <Col xs={12} md={(card == 'receita') ? 7 : 8}>
                                <InputIcon
                                    placeholder="Separe os emails por (,) virgula"
                                    type="text"
                                    id="sendEmailSolicExameEmail"
                                    value={emailSend}
                                    onChange={text => setEmailSend(text)}
                                    icon={IconEmail}
                                    style={{ width: '100%' }}
                                    disabled={disabled}
                                />
                                <p style={{ color: '#AAA', fontSize: 12 }}>*Separe os emails por (,) virgula. Ex: email@examplo.com, envio@exemplo.com</p>
                            </Col>
                            <Col xs={12} md={(card == 'receita') ? 5 : 4}>
                                {(card == 'receita') ? renderButtonEmailReceita() : renderButtonEmail()}
                            </Col>
                        </Row>
                        <hr />

                        <p style={{ fontSize: 16, fontWeight: 500 }}>Via WhatsApp:</p>

                        <Row>
                            <Col xs={12} md={(card == 'receita') ? 7 : 8}>
                                <InputIcon
                                    placeholder="Separe os numeros por (,) virgula"
                                    type="text"
                                    id="sendEmailSolicExameCel"
                                    value={telefonesSend}
                                    onChange={text => setTelefonesSend(text)}
                                    icon={IconFone}
                                    style={{ width: '100%' }}
                                    disabled={disabled}
                                />
                                <p style={{ color: '#AAA', fontSize: 12 }}>*Separe os numeros por (,) virgula. Ex: 11999998888, 11999997777</p>
                            </Col>
                            <Col xs={12} md={(card == 'receita') ? 5 : 4}>
                                {(card == 'receita') ? renderButtonWhatsReceita() : renderButtonWhats()}
                            </Col>
                        </Row>

                        <hr className="mt-2 mb-2" />

                        {(card == 'receita') ? renderFooterReceita() : renderFooter()}

                    </div>
                </div>
            </ModalComponent>
        </div>
    )

}

export default ModalEnvio;